// extracted by mini-css-extract-plugin
module.exports = {"formBox":"number-range_formBox__yrnj","input":"number-range_input_28agu","successColor":"number-range_successColor_1qQz1"};